import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a404faa04daac8492053ac007574b839ab from "./generated-a7902e78-222a-4f5b-bf21-5d5b122296c3.json";

import a4d91c74a89d8b9732e8185c852fa973cb from "./generated-7537b5b3-b41b-4140-aa96-6743ca83e66f.json";

import ac5bc2f8ec63f84fb291258063356a7a3b from "./generated-d7bc731c-7c9c-4f60-9ce1-69e871653bc7.json";

import a970770828beb535976ac88729cb7fa81b from "./generated-b65d2ff2-bc23-41aa-9eac-c019f156f1cb.json";

import a4017f50a6d01732333a0bcf31e2a9f61b from "./generated-4282c250-62c4-4bbe-8100-04e8adf43e45.json";

import a5f3d6059c5fd7a85ba7a9e7a4fc335d0b from "./generated-4e5f95de-c5cb-4188-8325-6c8cc0c0a2be.json";

import a84fba2bfa145752bd5128605bb768eb1b from "./generated-dcceeece-d575-4098-9cd7-a819ff1f6549.json";

import ac67e18bfd6ebeea3857fb0d14651e085b from "./generated-eddd637e-f172-45d4-8315-ab5202bf8b6f.json";

import a1ffcdfcb675632110f4e861d58cf96f5b from "./generated-886cee6d-bb23-4cf4-954a-cc6c9b70b704.json";

import a4e99e902261089fc7485042024f9729eb from "./generated-43fee240-7ca5-4002-abfc-7efa99312505.json";

import a019d57b7085f16bf6ae9b393e6f5cf65b from "./generated-a0145b0e-f912-4c31-a763-493421b50792.json";

import a17f7e3abfa1a8cf14d55b62ee4b77a4bb from "./generated-cb4cacac-dc50-49fc-9606-43d075b0c457.json";

import a31023b921ab2c6f68aa13528f5d546ecb from "./generated-280c78b4-76b7-4af0-8c9e-911ede4650e4.json";

import ab72d235a94cb421109557ecb261945a4b from "./generated-1cb6a399-a136-4faa-8437-33bb2725d8b1.json";

import a83eaa14b245dc8b61552324ee1c0556eb from "./generated-ac70d348-0aad-48fe-84e2-a7243a56df1d.json";

import a3bf1c93b54702c5beb010ebda610037ab from "./generated-caf0ef4c-d3ea-451f-9249-3900fa9cefa0.json";

import aea6d0421594797f4733da363ed130defb from "./generated-65e1926d-f86d-4a80-a2ae-1b33ac997305.json";

import acf21dc825fcfd20c69a61a297f3ac579b from "./generated-e9e1a214-49c9-4e20-be37-3527e37605d6.json";

import a0dd43671e791d7e2300c2bae4ec7717fb from "./generated-4fc32610-4d1a-4400-942d-e662fd6282b8.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a404faa04daac8492053ac007574b839ab);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a4d91c74a89d8b9732e8185c852fa973cb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ac5bc2f8ec63f84fb291258063356a7a3b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a970770828beb535976ac88729cb7fa81b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a4017f50a6d01732333a0bcf31e2a9f61b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5f3d6059c5fd7a85ba7a9e7a4fc335d0b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a84fba2bfa145752bd5128605bb768eb1b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ac67e18bfd6ebeea3857fb0d14651e085b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a1ffcdfcb675632110f4e861d58cf96f5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a4e99e902261089fc7485042024f9729eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a019d57b7085f16bf6ae9b393e6f5cf65b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a17f7e3abfa1a8cf14d55b62ee4b77a4bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a31023b921ab2c6f68aa13528f5d546ecb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ab72d235a94cb421109557ecb261945a4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a83eaa14b245dc8b61552324ee1c0556eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a3bf1c93b54702c5beb010ebda610037ab);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aea6d0421594797f4733da363ed130defb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(acf21dc825fcfd20c69a61a297f3ac579b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0dd43671e791d7e2300c2bae4ec7717fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aea6d0421594797f4733da363ed130defb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */